import React from 'react';
import { ButtonItems } from './Communication';
export function MainButtonLayout(props) {
    var buttonList = props.buttonList, onClick = props.onClick;
    return (React.createElement(React.Fragment, null, buttonList.map(function (item, index) { return (React.createElement(ButtonItems, { key: "button_" + index, onClick: function () { return onClick(item.id); }, id: "" + item.id },
        React.createElement("div", null, item.icons.map(function (icon) { return (React.createElement("img", { src: require("../../assets/icons/tct/" + icon + ".png"), height: "40", style: { marginRight: 5 } })); })),
        React.createElement("div", null, item.name))); })));
}
//# sourceMappingURL=MainButtonLayout.js.map